import React from "react"
import PropTypes from "prop-types"

class TopicSelector extends React.Component {
  render() {
    const { selectedTab, onSelectTab } = this.props;

    return(
      <div className="lex-dash-segmented exchangesPage__tabBar" role="tablist" aria-label="Activities view">
        <button
          type="button"
          role="tab"
          aria-selected={selectedTab === 1}
          className={`lex-dash-segmented__btn${selectedTab === 1 ? ' is-active' : ''}`}
          onClick={() => onSelectTab(1)}
        >
          Saved
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={selectedTab === 3}
          className={`lex-dash-segmented__btn${selectedTab === 3 ? ' is-active' : ''}`}
          onClick={() => onSelectTab(3)}
        >
          Search
        </button>
      </div>
    )
  }

}

TopicSelector.propTypes = {
  selectedTab: PropTypes.number.isRequired,
  onSelectTab: PropTypes.func.isRequired,
};

export default TopicSelector;
